/* global axios */
import ApiClient from '../ApiClient';

// R7.4: detratores vindos das redes sociais. Recurso singular, como o Farol e o Cruzamento.
class DetratoresAPI extends ApiClient {
  constructor() {
    super('fandata/detratores', { accountScoped: true });
  }

  // T-252: só canal. Detrator é quem reclamou, e a régua Bira × humano é sobre quem atendeu.
  get({ since, until, inboxId } = {}) {
    return axios.get(this.url, { params: { since, until, inbox_id: inboxId } });
  }
}

export default new DetratoresAPI();
